<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <importacion-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm" class="" @click="detalle(data.item)" v-b-tooltip.hover.top="'Detalle'" variant="flat-info">
              <feather-icon icon="BoxIcon" />
            </b-button>
            <b-button size="sm" class="" @click.prevent="edit(data.item)" v-b-tooltip.hover.top="'Editar'" variant="flat-success">
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" @click="deleteAction(data)" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script> 
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import importacionFilters from './importacionFilters.vue'
import ImportService from '@/services/ImportService'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return{
        showLoading: false,
        records: [],
        fields: [
          //{ key: 'id', label: 'N°', sortable: true },
          { key: 'enterprise', label: 'Empresa', sortable: false },
          { key: 'ruc', label: 'RUC Empresa', sortable: false },
          { key: 'dua', label: 'Dua', sortable: false },
          { key: 'establishments.name', label: 'Establecimiento', sortable: false},
          { key: 'actions', label: 'Acciones'}
        ],
        form:{
            id: null,
            typePurchase: '',
            enterprise: '',
            ruc: '',
            document: '',
            dua: '',
            establishments: '',
        },
        arrayFilters: [],
        currentPage: 1,
        entries: [10, 20, 50, 100],
        showEntrie: 10,
        totalElements: 0,
        id: 0,
        sort: 'id',
        order: 'desc',
    }
  },
  components:{
    importacionFilters
  },
  mounted(){
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    detalle(data){
      this.$router.push({
        path: `/importacion/${data.id}/detalle`,
        query: { establishmentId: data.establishments.id }
      })
    },
    edit(item){
      console.log('item',item)
      this.form.id = item.id
      this.form.enterprise = item.enterprise
      this.form.ruc = item.ruc
      this.form.dua = item.dua  
      this.form.establishmentId = item.establishments.id

      this.$refs.filters.isAdd = true
      this.$refs.filters.$children[0].getData(this.form)
      console.log('this.$refs.filters', this.$refs.filters)
    },
    async getData(){
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await ImportService.getImports(url, this.$store)
      console.log('resp Imports: ',resp)
      if (resp.data.rows.length != 0) {
        this.records = resp.data.rows
        this.totalElements = resp.data.rows.length
      }
      this.showLoading = false
    },
    async deleteAction(data) {
      this.$swal({
        title: '¿Desea eliminar esta importación?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminalo',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1
          this.$swal({
            icon: 'success',
            title: 'Eliminado!',
            text: 'La importación ha sido eliminado.',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
          this.deleteData(data.item.id)
        }
      })
    },
    async deleteData(id) {
      const resp = await ImportService.deleteImport(id, this.$store)
      console.log('resp delete',resp)
      if (resp) {
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al eliminar la importación.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
      console.log('respDelete', resp)
    },
  },
}


</script>